module.exports = __webpack_public_path__ + "static/img/welcome-banner.a3b9488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/welcome-banner.png
// module id = u4Q2
// module chunks = 1